<template>
  <div class="main">
    <!--顶部-->
    <div class="trendtop orangeToYellow">
      <div
        class="trendtop_left fs40 ellipsis"
        :class="ischange == true ? 'on' : ''"
        @click="showChangeTrend"
      >
        <p>{{ monlist[des] }}</p>
      </div>
      <div class="trendtop_right">
        <span class="span1" @click="showEditTask(1)">
          <font class="fs32">＋</font>
          {{$t('first.addtask')}}
        </span>
      </div>
    </div>
    <van-popup
      v-model="ishow"
      position="bottom"
      :style="{ height: '40%' }"
      @click-overlay="onCancel"
    >
      <van-picker
        :title="$t('trend.trend_chose')"
        :confirm-button-text="$t('member.login_out_ok')"
        :cancel-button-text="$t('member.login_out_cancel')"
        show-toolbar
        :columns="monlist"
        :default-index="des"
        @confirm="onConfirm"
        @cancel="onCancel"
      />
    </van-popup>
    <!--顶部 end-->
    <!--任务列表-->
    <div class="tasklists">
      <div class="tasklist" v-for="(item, index) in tasklist" :key="index">
        <div class="tasklist_top">
          <div class="tasklist_top_left">{{index+1}}.{{item.name}}</div>
          <div
            class="tasklist_top_status red"
            v-show="item.jobStatus==1"
          >{{$t('first.tsak_status1')}}</div>
          <div
            class="tasklist_top_status green"
            v-show="item.jobStatus==2"
          >{{$t('first.tsak_status2')}}</div>
          <div
            class="tasklist_top_status yellow"
            v-show="item.jobStatus==3"
          >{{$t('first.tsak_status3')}}</div>
        </div>
        <div class="tasklist_bot">
          <div class="tasklist_bot_left">
            <div class="taskm">{{$t('first.task_edit_form1')}}：{{item.jobId}}</div>
            <div class="taskm">{{$t('first.task_edit_form2')}}：{{item.startTime}}</div>
            <div class="taskm">{{$t('first.task_edit_form3')}}：{{item.endTime}}</div>
            <div
              class="taskm"
              v-show="item.type==1"
            >{{$t('first.task_edit_form4')}}：{{$t('first.task_edit_type1')}}</div>
            <div
              class="taskm"
              v-show="item.type==2"
            >{{$t('first.task_edit_form4')}}：{{$t('first.task_edit_type2')}}</div>
            <div
              class="taskm"
              v-show="item.type==3"
            >{{$t('first.task_edit_form4')}}：{{$t('first.task_edit_type3')}}</div>
          </div>
        </div>
        <div class="tasklist_bot2">
          <div class="sbtn sbtn1" @click="doEdit(item.jobId)">{{$t('first.task_edit_do')}}</div>
          <div class="sbtn sbtn2" @click="doDelete(item.jobId)">{{$t('first.task_edit_delete')}}</div>
        </div>
      </div>
    </div>
    <!--任务列表 end-->
    <!--创建任务弹窗-->
    <van-popup v-model="istask" class="bigeditask">
      <div class="editask">
        <div class="editask_title">
          {{edit_title}}{{$t('first.task')}}
          <span class="close" @click="closeTask">
            <img src="../../assets/images/close.png">
          </span>
        </div>
        <div class="editask_center">
          <!--one-->
          <div class="edit_form">
            <div class="edit_title">{{$t('first.task_edit_start_time')}}</div>
            <div class="edit_input">
              <div class="starttime tim" @click="setTime(1)">{{ time1 }}</div>
            </div>
          </div>
          <!--one end-->
          <!--one-->
          <div class="edit_form">
            <div class="edit_title">{{$t('first.task_edit_end_time')}}</div>
            <div class="edit_input">
              <div class="starttime tim" @click="setTime(2)">{{ time2 }}</div>
            </div>
          </div>
          <!--one end-->
          <!--one-->
          <div class="edit_form">
            <div class="edit_title">{{$t('first.task_edit_pl')}}</div>
            <div class="edit_input tim3">
              <van-radio-group v-model="task_type" direction="horizontal">
                <van-radio class="rad" name="1">{{$t('first.task_edit_type1')}}</van-radio>
                <van-radio class="rad" name="2">{{$t('first.task_edit_type2')}}</van-radio>
                <van-radio class="rad" name="3" disabled>{{$t('first.task_edit_type3')}}</van-radio>
              </van-radio-group>
            </div>
          </div>
          <!--one end-->
        </div>
        <div class="editask_bot">
          <div
            class="doEditValva orangeToYellow"
            @click="doEditValva"
          >{{edit_title}}{{$t('first.task')}}</div>
        </div>
      </div>
    </van-popup>
    <!--开始时间-->
    <van-popup
      v-model="istart"
      overlay-class="myshade"
      position="bottom"
      :style="{ height: '30%' }"
      @click-overlay="setShade"
    >
      <!-- <van-datetime-picker @confirm="doConfirm" @cancel="doCancel" type="datetime" :title="$t('export.time_title')" :confirm-button-text="$t('member.login_out_ok')" :cancel-button-text="$t('member.login_out_cancel')"
                :min-date="sminDate"
                :max-date="smaxDate"
      />-->
      <van-picker
        @confirm="doConfirm"
        @cancel="doCancel"
        show-toolbar
        :title="$t('first.time')"
        :columns="times"
      />
    </van-popup>
    <!--开始时间 end-->
    <!--结束时间-->
    <van-popup
      v-model="iend"
      overlay-class="myshade"
      position="bottom"
      :style="{ height: '30%' }"
      @click-overlay="setShade"
    >
      <!-- <van-datetime-picker v-model="currentDate"  @confirm="doConfirm" @cancel="doCancel" type="datetime" :title="$t('export.time_title')"  :confirm-button-text="$t('member.login_out_ok')" :cancel-button-text="$t('member.login_out_cancel')"
                :min-date="eminDate"
                :max-date="emaxDate"
      />-->
      <van-picker
        @confirm="doConfirm"
        @cancel="doCancel"
        show-toolbar
        :title="$t('first.time')"
        :columns="times"
      />
    </van-popup>
    <!--结束时间 end-->
    <!--创建任务弹窗 end-->
    <pageToast ref="pageToast"></pageToast>
    <customFooter :ison="2"></customFooter>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentDate: new Date(),
      index: 0,
      ishow: false,
      ischange: false,
      istask: false, //是否弹出编辑任务层
      no: localStorage.getItem("no") ? localStorage.getItem("no") : "", //设备号
      valvaid: "", //阀门id
      monlist: [],
      edit_type: 1, //新增 2修改
      edit_title: this.$t("first.task_edit_add"),

      isopen: "1",
      choselist: "", //选中的阀门
      des: 0, //选中阀门索引
      valist: "", //阀门列表

      //一下为时间参数
      times: [],

      istart: false,
      iend: false,
      itype: 1,
      time1: "",
      time2: "",

      //编辑任务参数
      task_type: "1", //任务类型
      tasklist: "", //任务列表
      tasknow: "" //当前选中的任务
    };
  },
  created() {
    var id = this.$route.query.id;
    this.valvaid = id;
  },

  mounted() {
    //创建图表
    this.$nextTick(function() {
      this.getValaveList(this.no);
      this.setTimesVal();
    });
  },
  methods: {
    //设置picker时间值
    setTimesVal() {
      var myDate = new Date(); //实例一个时间对象
      var h = myDate.getHours(); //获取系统时，
      var m = myDate.getMinutes(); //分
      var s = myDate.getSeconds(); //秒
      var hour = new Array(),
        minute = new Array(),
        second = new Array();
      for (var i = 0; i < 24; i++) {
        hour.push(this.$padStart(i));
      }
      for (var i = 0; i < 60; i++) {
        minute.push(this.$padStart(i));
        second.push(this.$padStart(i));
      }
      var times = [
        {
          values: hour,
          defaultIndex: h
        },
        {
          values: minute,
          defaultIndex: m
        },
        {
          values: second,
          defaultIndex: s
        }
      ];
      this.times = times;
      this.time1 =
        this.$padStart(h) + ":" + this.$padStart(m) + ":" + this.$padStart(s);
      this.time2 =
        this.$padStart(h) + ":" + this.$padStart(m) + ":" + this.$padStart(s);
    },

    //设备选择
    showChangeTrend() {
      this.ishow = true;
      this.ischange = true;
    },

    setShade() {
      this.ischange = false;
      this.ishow = false;
    },

    //时间选择取消
    doConfirm(value) {
      if (this.itype == 1) {
        this.istart = false;
        this.time1 = value[0] + ":" + value[1] + ":" + value[2];
      } else {
        this.iend = false;
        this.time2 = value[0] + ":" + value[1] + ":" + value[2];
      }
    },
    doCancel() {
      if (this.itype == 1) {
        this.istart = false;
      } else {
        this.iend = false;
      }
    },

    //时间选择
    setTime(i) {
      if (i == 1) {
        this.istart = true;
        this.iend = false;
      } else if (i == 2) {
        this.istart = false;
        this.iend = true;
      }
      this.itype = i;
    },

    //弹出编辑任务
    showEditTask(i) {
      this.edit_type = i;
      this.istask = true;
      if (i == 1) {
        this.edit_title = this.$t("first.task_edit_add");
      } else {
        this.edit_title = this.$t("first.task_edit_do");
      }
    },

    //关闭任务编辑
    closeTask() {
      this.istask = false;
    },

    //查询阀门
    getValaveList(no) {
      if (this.$isblank(no)) {
        this.$toast(this.$t("export.tis_dev"));
        return false;
      }
      var valvaid = this.valvaid;
      var _this = this;
      this.$api
        .getValaveList({
          gatewayNo: no
        })
        .then(res => {
          //.log(res);
          if (res.errcode == 0) {
            var monlist = new Array();
            var choselist = "";
            var des = _this.des;
            if (!_this.$isblank(res.list)) {
              var list = res.list;
              for (var i = 0; i < list.length; i++) {
                monlist.push(list[i].name);
                if (list[i].id == valvaid) {
                  des = i;
                }
              }
              choselist = list[des];
              _this.des = des;
              _this.valist = list;
              _this.monlist = monlist;
              _this.choselist = choselist;
              _this.getValvaTaskList(choselist.id);
            } else {
              _this.$refs.pageToast.type = 1;
            }
          } else {
            _this.$toast(res.errmsg);
            return false;
          }
        });
    },

    //读取任务列表
    getValvaTaskList(id) {
      var _this = this;
      this.$api
        .getValvaTaskList({
          valveId: id
        })
        .then(res => {
          console.log(res);
          if (res.errcode == 0) {
            if (!_this.$isblank(res.data)) {
              var list = [res.data];
              _this.tasklist = list;
              _this.$refs.pageToast.type = 0;
            } else {
              _this.$refs.pageToast.type = 1;
            }
          } else {
            _this.$toast(res.errmsg);
            _this.$refs.pageToast.type = 1;
          }
        });
    },

    //阀门点击
    onConfirm(value, index) {
      this.ischange = false;
      this.ishow = false;
      var valist = this.valist; //阀门列表
      var choselist = "";
      var des = this.des;
      if (!this.$isblank(valist)) {
        for (var i = 0; i < valist.length; i++) {
          if (valist[i].id == value) {
            des = i;
            this.valvaid = valist[i].id;
          }
        }

        choselist = valist[des];
        this.des = des;
        this.choselist = choselist;
        this.getValvaTaskList(choselist.id);
      }
    },

    //编辑任务
    doEditValva() {
      var edit_type = this.edit_type;
      var _this = this;
      var startTime = this.time1;
      var endTime = this.time2;
      var type = this.task_type;
      var valveId = this.valvaid;
      if (edit_type == 1) {
        this.$api
          .doAddValva({
            startTime: startTime,
            endTime: endTime,
            type: parseInt(type),
            valveId: parseInt(valveId)
          })
          .then(res => {
            console.log(res);
            if (res.errcode == 0) {
              _this.istask = false;
              _this.$toast.success(_this.$t("first.task_edit_success1"));
              _this.getValvaTaskList(_this.choselist.id);
            } else {
              _this.$toast(res.errmsg);
            }
          });
      } else if (edit_type == 2) {
        this.$api
          .doEditValva({
            jobId: _this.tasknow.jobId,
            startTime: startTime,
            endTime: endTime,
            type: parseInt(type),
            valveId: parseInt(valveId)
          })
          .then(res => {
            console.log(res);
            if (res.errcode == 0) {
              _this.istask = false;
              _this.$toast.success(_this.$t("first.task_edit_success2"));
              _this.getValvaTaskList(_this.choselist.id);
            } else {
              this.$toast(res.errmsg);
            }
          });
      }
    },

    //阀门选择取消
    onCancel(e) {
      this.ischange = false;
      this.ishow = false;
    },

    //编辑任务
    doEdit(jobid) {
      //查询任务tasknow
      var _this = this;
      this.$toast.loading({
        message: this.$t("trend.data_loading"),
        forbidClick: true,
        duration: 0
      });
      this.$api
        .getOneTaskDetail({
          jobId: jobid
        })
        .then(res => {
          _this.$toast.clear();
          console.log(res);
          if (res.errcode == 0) {
            if (!_this.$isblank(res.data)) {
              _this.tasknow = res.data;
              _this.time1 = res.data.startTime;
              _this.time2 = res.data.endTime;
              _this.task_type = res.data.type.toString();
              _this.showEditTask(2);
            } else {
              _this.$toast(_this.$t("common.nodata"));
            }
          } else {
            _this.$toast(res.errmsg);
          }
        });
    },

    //删除任务
    doDelete(jobid) {
      var _this = this;
      this.$dialog
        .confirm({
          title: this.$t("member.login_out_title"),
          message: this.$t("first.task_delete_msg"),
          confirmButtonText: this.$t("member.login_out_ok"),
          cancelButtonText: this.$t("member.login_out_cancel")
        })
        .then(() => {
          this.$api
            .doDeleteValva({
              jobId: jobid
            })
            .then(res => {
              //console.log(res);
              if (res.errcode == 0) {
                _this.$toast(_this.$t("first.task_delete_success"));
                setTimeout(function() {
                  //_this.$router.push({ path:'/login'  })
                  _this.getValvaTaskList(_this.choselist.id);
                }, 2000);
              } else {
                _this.$toast(res.errmsg);
              }
            });
        })
        .catch(err => {
          //其他异常
          _this.$toast.clear();
        });
    }
  }
};
</script>

<style>
body {
  background: #f4f4f4;
}
/*top*/
/*top*/
.trendtop {
  overflow: hidden;
  line-height: 30px;
  padding: 15px 10px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  box-sizing: border-box;
  z-index: 9999999999;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.3);
}
.trendtop .trendtop_left {
  color: #fff;
  padding: 0 0.4rem 0 0;
  float: left;
  position: relative;
  max-width: 3rem;
  font-size: 15px;
  font-weight: 700;
}
.trendtop .trendtop_left .number {
  font-size: 13px;
  font-weight: normal;
  opacity: 0.7;
  line-height: 1;
}
.trendtop .trendtop_left::after {
  position: absolute;
  content: "";
  width: 0.14rem;
  height: 0.14rem;
  border-top: 2px solid #fff;
  border-right: 2px solid #fff;
  transform: rotate(45deg);
  top: 50%;
  margin-top: -0.09rem;
  right: 0.1rem;
  -webkit-transition: all 0.3s ease 0s;
  -o-transition: all 0.3s ease 0s;
  transition: all 0.3s ease 0s;
}
.trendtop .trendtop_left.on::after {
  -webkit-transform: rotate(135deg);
  -moz-transform: rotate(135deg);
  -o-transform: rotate(135deg);
  -ms-transform: rotate(135deg);
  transform: rotate(135deg);
}
.trendtop .trendtop_right {
  float: right;
  overflow: hidden;
  color: #fff;
  opacity: 1;
  font-weight: 700;
  font-size: 12px;
  height: 30px;
  line-height: 30px;
  position: relative;
  padding-right: 16px;
}
.trendtop .trendtop_right .img1 {
  width: 12px;
  height: 12px;
  float: right;
  margin-left: 5px;
  position: absolute;
  top: 50%;
  margin-top: -6px;
  right: 0;
}
.trendtop .trendtop_right .img1.on {
  animation: run 2s linear 0s infinite;
}
.trendtop_right .span1 {
  color: #fff;
}
.trendtop_right font {
  float: left;
}
/*top end*/

/*任务列表*/
.tasklists {
  padding-top: 1.3rem;
}
.tasklist {
  width: 6.7rem;
  margin: 0 auto 0.2rem;
  padding: 0 0.2rem;
  background: #fff;
  border-radius: 10px;
}
.tasklist .tasklist_top {
  border-bottom: 1px solid #eee;
  overflow: hidden;
  line-height: 45px;
}
.tasklist .tasklist_top .tasklist_top_left {
  float: left;
  font-size: 16px;
  font-weight: bold;
}
.tasklist .tasklist_top .tasklist_top_status {
  float: right;
  font-size: 14px;
}
.tasklist_bot {
  overflow: hidden;
  padding: 0.1rem 0;
  border-bottom: 1px solid #eee;
}
.tasklist_bot .tasklist_bot_left {
  font-size: 14px;
  line-height: 24px;
}
.tasklist_bot2 {
  text-align: right;
  text-align: right;
  padding: 10px 0;
  overflow: hidden;
}
.tasklist_bot2 .sbtn {
  display: inline-block;
  line-height: 30px;
  padding: 0 10px;
  margin-left: 10px;
  font-size: 14px;
  color: #fff;
  border-radius: 6px;
  vertical-align: middle;
  float: right;
}
.tasklist_bot2 .sbtn.sbtn1 {
  background: rgba(53, 105, 233, 0.9);
}
.tasklist_bot2 .sbtn.sbtn2 {
  background: #f00;
}
.van-toast {
  z-index: 10000 !important;
}
/*任务列表 end*/

/*时间选择*/
.times {
  padding-top: 0rem;
  text-align: center;
}
.times .tim {
  width: 3.1rem;
  padding: 0.25rem 0;
  display: inline-block;
  border-radius: 0.1rem;
  background: #fff;
  margin: 0.4rem 0.1rem 0 0.1rem;
  font-size: 16px;
}
.foremail {
  width: 6.4rem;
  margin: 0.4rem auto;
  border-radius: 0.1rem;
  background: #fff;
  overflow: hidden;
}
.foremail input {
  width: 100%;
  text-indent: 0.1rem;
  font-size: 16px;
  color: #333;
  padding: 0.25rem 0;
  float: left;
}
/*时间选择 end*/
.doexcel {
  width: 6.4rem;
  margin: 0 auto;
  border-radius: 0.1rem;
  text-align: center;
  padding: 0.2rem 0;
  font-size: 16px;
  background: #2255d2;
  color: #fff;
}

.valist {
  width: 6.9rem;
  margin: 0 auto;
  padding-top: 1.5rem;
}
.vatop {
  overflow: hidden;
}
.va {
  overflow: hidden;
  background: #fff;
  padding: 0.2rem;
  border-radius: 0.1rem;
  box-shadow: 0 0 0.1rem #eee;
  margin-bottom: 0.2rem;
}
.va .valeft {
  width: 5rem;
  float: left;
}
.va .valeft .va_title {
  color: #333;
}
.va .valeft .va_title .txt2 {
  color: #999;
  padding-left: 0.3rem;
}
.va .valeft .va_time {
  color: #999;
  padding-top: 0.15rem;
}
.va .valeft .va_time .img1 {
  width: 0.3rem;
  vertical-align: middle;
  margin: -0.05rem 0.08rem 0 0;
}
.va .varight {
  float: right;
  padding-top: 0.2rem;
}
.vatask {
  overflow: hidden;
  border-top: 1px dashed #ddd;
  margin-top: 0.2rem;
  padding-top: 0.15rem;
}
.vatask .vatask_left {
  float: left;
  line-height: 0.45rem;
}
.vatask .vatask_right {
  float: right;
}
.vatask .vatask_right a {
  display: block;
  height: 0.45rem;
  line-height: 0.45rem;
  text-align: center;
  padding: 0 0.15rem;
  color: #fff;
  background: rgba(24, 76, 204, 1);
  border-radius: 0.1rem;
}

/*编辑任务*/
.myshade {
}
.bigeditask {
  border-radius: 15px;
  overflow: hidden;
  z-index: 9999 !important;
  padding-bottom: 15px;
}
.editask {
  width: 5.8rem;
  background: #fff;
  min-height: 2rem;
  padding: 0 0.2rem;
}
.editask .editask_title {
  text-align: center;
  padding: 0.15rem 0;
  border-bottom: 1px solid #eee;
  font-size: 20px;
  position: relative;
}
.editask .editask_title .close {
  position: absolute;
  width: 0.29rem;
  height: 0.29rem;
  right: 0.15rem;
  top: 0.25rem;
}
.editask_center {
  padding: 0.15rem 0 0;
}
.edit_form {
  overflow: hidden;
  margin: 0.3rem 0 0;
}
.edit_form .edit_title {
  float: left;
  font-size: 14px;
  width: 65px;
  padding: 0.25rem 0;
}
.edit_form .edit_input {
  padding-left: 65px;
  font-size: 14px;
}
.rad {
  margin: 0 15px 10px 0;
}
.edit_form .tim {
  width: 90%;
  padding: 0.25rem 0 0.25rem 0.15rem;
  display: inline-block;
  border-radius: 0.1rem;
  background: #fff;
  margin: 0rem 0.1rem 0 0.1rem;
  font-size: 14px;
  border: 1px solid #ddd;
}
.edit_form .tim3 {
  padding: 0.25rem 0;
}
.doEditValva {
  width: 90%;
  margin: 0 auto;
  border-radius: 5px;
  text-align: center;
  font-size: 14px;
  color: #fff;
  height: 40px;
  line-height: 40px;
}
</style>
